<template>
  <div>
    <table class="table booking-table text-[15px]">
      <thead>
        <tr>
          <th class="cabin">舱房</th>
          <th class="sale-prices">同行价</th>
          <th class="sug-sale-prices">建议零售价</th>
          <th class="num" colspan="2">
            人数/房间数
            <!-- <i
              class="tip-icon ficon ficon-wenhao"
              v-tooltip="{
                html: true,
                content: tip
              }"
            ></i> -->
            <el-popover class="header-people-tip" :visible-arrow="false" popper-class="border border-warn">
              <i slot="reference" class="tip-icon ficon ficon-wenhao" />
              <!-- <template v-slot:popover> -->
              <div class="header-people-tip-content">
                <pre>
1.每间房至少入住一位成人，当房间入住人数达到4人时，（最多）提供2张正常床和一张加床，第四位只能为儿童入住，且不占床。

2.当房间入住人数超过2人时，第3、4位入住人为儿童时，默认按照儿童不占床价格呈现，若资源充足，您也可以选择其他选项。
                  </pre>
              </div>
              <!-- </template> -->
            </el-popover>
          </th>
          <th class="total">
            <el-button type="default" size="small" v-if="hasAlliance" @click="handleShowCabin">库存明细</el-button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="stock in cabinTable" :key="stock.id">
          <td class="cabin">
            <div class="cabin-img overflow-hidden">
              <el-image class="cabin-img-inner" fit="cover" :src="stock.cabin.images"
                @click="showCanbinDetailWithDialog(stock)" />
            </div>
            <div class="cabin-content">
              <h3 class="cabin-title text-secondary flex cursor-pointer transition-colors hover:text-primary" @click="showCanbinDetailWithDialog(stock)" >
                <div class="flex">{{ stock.cabin_name }}</div>
                <i class="el-icon-arrow-right ml-1"></i>
              </h3>
              <p class="cabin-detail">
                {{ stock.cabin.room_area }}
                <v-divider direction="vertical" />
                {{ stock | peopleStr }}
                <br />
                {{ stock.cabin.window_label }}
                <template v-if="stock.cabin.window_area">
                  ({{ stock.cabin.window_area }})
                </template>
                <v-divider direction="vertical" />{{
                  stock.cabin.floor_label.join(",")
                }}层
              </p>
            </div>
          </td>
          <td class="sale-prices">
            <el-popover popper-class="border border-warn" :visible-arrow="false" trigger="hover">
              <div slot="reference">
                <template v-if="cruiseType === 1">
                  <p v-if="stock.prices.th.adult_price" class="price leading-6">
                    ￥{{ stock.prices.th.adult_price }}/成人
                  </p>
                  <p v-if="stock.prices.th.child_price" class="price leading-6">
                    ￥{{ stock.prices.th.child_price }}/儿童
                  </p>
                </template>
                <template v-else>
                  <p v-if="stock.prices.th.adult_price" class="price leading-6">
                    ￥{{ stock.prices.th.adult_price }}/第1/2人
                  </p>
                  <p v-if="stock.prices.th.adult34_price" class="price leading-6">
                    ￥{{ stock.prices.th.adult34_price }}/第3/4成人
                  </p>
                  <p v-if="stock.prices.th.child34_price" class="price leading-6">
                    ￥{{ stock.prices.th.child34_price }}/第3/4儿童
                  </p>
                </template>
              </div>
              <TablePriceTip :data="stock.prices.th" />

            </el-popover>
          </td>
          <td class="sug-sale-prices">
            <el-popover popper-class="border border-warn" :visible-arrow="false" trigger="hover">
              <div slot="reference">
                <template v-if="cruiseType === 1">
                  <p v-if="stock.prices.sale.adult_price" class="price leading-6">
                    ￥{{ stock.prices.sale.adult_price }}/成人
                  </p>
                  <p v-if="stock.prices.sale.child_price" class="price leading-6">
                    ￥{{ stock.prices.sale.child_price }}/儿童
                  </p>
                </template>
                <template v-else>
                  <p v-if="stock.prices.sale.adult_price" class="price leading-6">
                    ￥{{ stock.prices.sale.adult_price }}/第1/2人
                  </p>
                  <p v-if="stock.prices.sale.adult34_price" class="price leading-6">
                    ￥{{ stock.prices.sale.adult34_price }}/第3/4成人
                  </p>
                  <p v-if="stock.prices.sale.child34_price" class="price leading-6">
                    ￥{{ stock.prices.sale.child34_price }}/第3/4儿童
                  </p>
                </template>
              </div>
              <!-- <template #popover> -->
              <TablePriceTip :data="stock.prices.sale" />
              <!-- </template> -->
            </el-popover>
          </td>
          <td class="num">
            <p :class="['p_num', { 'add-top-pannel': !(stock.max_people > 1) }]">
              <span class="tourist-label">成人</span>
              <el-input-number size="mini" class="num-input" v-model="stock.adultNum" :min="0" />
            </p>
            <p v-if="stock.max_people > 1" class="p_num">
              儿童
              <el-input-number size="mini" class="num-input" v-model="stock.childNum" :max="stock.maxChildNum"
                :min="0" />
            </p>
            <p v-if="stock.canChildAddBed" class="p_num">
              儿童加床数
              <el-input-number size="mini" class="num-input" v-model="stock.childBedNum" :min="0"
                :max="stock.maxChildBedNum" />
            </p>
            <p v-if="stock.diffRoomPriceNum" class="p_num">
              单房差 x {{ stock.diffRoomPriceNum }}
            </p>
          </td>
          <td class="room-num">
            <p class="room-num-text">{{ stock.last_stock | mapStockText }}</p>
            <el-input-number size="mini" v-model="stock.roomNum" :min="stock.minRoomNum" :max="stock.maxRoomNum"
              :step="stock.roomNumStep" />
            <p class="room-num-message" v-if="!stock.validResult.valid">
              {{ stock.validResult.errors[0] }}
            </p>
            <p class="room-num-message" v-if="stock.messages">
              {{ stock.messages }}
            </p>
          </td>
          <td class="total">
            <template v-if="stock.totalPrice > 0">
              <p class="total-prices">
                <span class="amount text-price">
                  ￥<span class="num">{{ stock.totalPrice }}</span>
                </span>
                <el-popover class="d-inline-block price-popover" popper-class="border border-warn !py-0" :visible-arrow="false" :container="false">
                  <i slot="reference" class="tip-icon ficon ficon-tanhao" />
                  <div class="price-wraper">
                      <div class="price-header">
                        总计：<span class="price-text !text-price">￥{{ stock.totalPrice }}</span>
                        <span class="profit-text">利润：￥{{ stock.totalProfit }}</span>
                      </div>
                      <div class="price-table">
                        <dl v-for="(priceRow, index) in stock.totalPriceList" :key="index" class="price-row">
                          <dt class="price-row-label">{{ priceRow.title }}</dt>
                          <dd class="nums">x {{ priceRow.num }}</dd>
                          <dd class="price-text !text-price font-medium">
                            ￥{{ priceRow.totalPrice }}
                          </dd>
                          <dd class="profit-text">
                            利润：￥{{ priceRow.profit }}
                          </dd>
                        </dl>
                      </div>
                    </div>
                </el-popover>
                <br /><span class="profit-tag">利润：￥{{ stock.totalProfit }}</span>
              </p>
            </template>
            <p v-else class="total-prices-tip leading-5">请先在左侧<br />选择入住人数</p>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- <submit-bar
      :amount="totalAmount"
      :profit="totalProfit"
      :people-num="totalPeople"
      :room-num="totalRoom"
      @on-submit="handleSubmit"
    >
      <template #price-table>
        <div class="price-wraper">
          <div class="price-header">
            共{{ totalRoom }}间，总计：<span class="price-header-total"
              >¥{{ totalAmount }}</span
            >
            <span> 利润：¥{{ totalProfit }}</span>
          </div>
          <div class="price-table">
            <dl v-for="row in totalPriceTable" :key="row.id" class="price-row">
              <dt class="price-row-label">{{ row.cabin_name }}</dt>
              <dd class="nums">{{ row.roomNum }}间</dd>
              <dd>
                <span class="total-price">¥ {{ row.totalPrice }}</span
                >，<span class="profit-color"
                  >利润 ¥ {{ row.totalProfit }}</span
                >
              </dd>
            </dl>
          </div>
        </div>
      </template>
    </submit-bar> -->
  </div>
</template>

<script>
// import StockData from "./cabin";
// import SubmitBar from "./DetailBookingSubmitBar";
import TablePriceTip from "@/views/product/DetailBookingTablePriceTip";

// import VDialog from 'src/components/VDialog/'
import { floatAdd, sum } from "@/utils/helpers";
import { InlandBulk, OceanBulk } from "./components/booking/index";

import { submitOrderBooking } from "@/services/order";
import { defineComponent } from "@nuxtjs/composition-api";


// import Main from '@/components/ScrollActive';
// import { mapActions, mapState } from "vuex";
// import { MESSAGE_TYPES, NOTIFY_GROUPS } from "@/constants/const-http";

// config
// const mapSaleType = {
//   bulk: 1,
//   cut: 2
// };

export default defineComponent({
  name: "BookingBulk",
  components: { TablePriceTip },
  filters: {
    peopleStr(stock) {
      return stock.min_people === stock.max_people
        ? `必须入住${stock.min_people}人`
        : [stock.min_people, stock.max_people].join("-") + "人";
    },
    mapStockText(stock) {
      if (stock > 20) {
        return "充足";
      } else if (stock > 5) {
        return "少量";
      } else if(stock > 0) {
        return `仅剩${stock}间`
      } else {
        return "库存现询";
        // return "二次确认";
      }
      // return stock > 10 ? "库存充足" : `仅剩${stock}间`;
    },
  },
  props: {
    productNo: {
      type: String,
      default: "",
    },
    hasAlliance: Boolean,
    cruiseType: {
      type: [Number, String],
      default: 1,
    },
    defaultData: {
      type: Array,
      default: () => [],
    },
    stockData: {
      type: Array,
      default: () => [],
    },
    bookingType: String,
    currentVoyage: {
      type: Object,
      default: () => ({}),
    },
    class_id: {
      type: [Number, String],
      default: "",
    }
  },
  data() {
    return {
      tip: "1.每间房至少入住一位成人，当房间入住人数达到4人时，（最多）提供2张正常床和一张加床，第四位只能为儿童入住，且不占床。<br />2.当房间入住人数超过2人时，第3、4位入住人为儿童时，默认按照儿童不占床价格呈现，若资源充足，您也可以选择其他选项。",
      // id: generateId(),
      model: "",
      // stockData: StockData,
      priceTable: [],
      cabinTable: [],
    };
  },
  computed: {
    // ...mapState("product/booking", [
    //   "stockData",
    //   "bookingType",
    //   "currentVoyage"
    // ]),
    totalPriceTable() {
      // console.log(this.priceTable);
      return this.priceTable.filter((row) => row.totalPeople > 0);
    },
    totalAmount() {
      return this.totalPriceTable.reduce((sum, row) => floatAdd(sum, row.totalPrice), 0);  //sum();
    },
    totalProfit() {
      // return sum(this.totalPriceTable.map((row) => row.totalProfit));
      return  this.totalPriceTable.reduce((sum, row) => floatAdd(sum, row.totalProfit), 0);
    },
    totalPeople() {
      // return sum(
      //   this.totalPriceTable.map((row) => sum([row.adultNum, row.childNum]))
      // );

      return  this.totalPriceTable.reduce((sum, row) => floatAdd(sum, floatAdd(row.adultNum, row.childNum)), 0);
    },
    totalRoom() {
      // return sum(this.totalPriceTable.map((row) => row.roomNum));
      return  this.totalPriceTable.reduce((sum, row) => floatAdd(sum, row.roomNum), 0);
    },
    emitValue() {
      return {
        amount: this.totalAmount,
        profit: this.totalProfit,
        "people-num": this.totalPeople,
        "room-num": this.totalRoom,
        totalPriceTable: this.totalPriceTable,
      };
    },
  },
  watch: {
    stockData: {
      immediate: true,
      handler(stocks) {
        this.priceTable = stocks.map((stock) => {
          let row =
            this.cruiseType == 1 ? new InlandBulk(stock) : new OceanBulk(stock);
          let defaultData = this.defaultData.find(
            (item) => item.class_id == stock.class_id
          );

          if (!defaultData) return row;
          Object.assign(row, {
            roomNum: defaultData.room_num,
            childNum: defaultData.child_num,
            adultNum: defaultData.adult_num,
            // _diffRoomNum: defaultData.diff_room_num,
            childBedNum: defaultData.child_bed_num,
          });
          row.validate && row.validate();
          return row;
        });
        this.cabinTable = this.priceTable.filter(item => item.cabin_class_id === this.class_id);
      },
    },
    defaultData(values) {
      if (!this.priceTable.length) return;
      this.priceTable = this.priceTable.map((row) => {
        let defaultData = values.find((item) => item.class_id == row.class_id);

        if (!defaultData) return row;
        Object.assign(row, {
          roomNum: defaultData.room_num,
          childNum: defaultData.child_num,
          adultNum: defaultData.adult_num,
          // _diffRoomNum: defaultData.diff_room_num,
          childBedNum: defaultData.child_bed_num,
        });
        row.validate && row.validate();
        return row;
      });
    },
    emitValue: {
      deep: true,
      handler: function (value) {
        this.$emit("input", value);
      },
    },
    class_id(values) {
      this.cabinTable = this.priceTable.filter(item => item.cabin_class_id === values);
    }
  },
  mounted() { },
  methods: {
    // ...mapActions("product/booking", ["submitOrderBooking"]),
    handleShowCabin() {
      this.$emit("onShowStock");
    },
    async submitOrderBooking(params) {
      let { code, data, msg } = await submitOrderBooking(params);
      if (code !== 10000) {
        return { code, msg };
      }
      return { code, data, msg };
    },
    async handleSubmit() {
      let cabins = this.priceTable;

      let errorCabin = cabins.find((cabin) => !cabin.validResult.valid);
      if (errorCabin) {
        this.$message.error(errorCabin.validResult.errors[0]);
        return;
      }
      cabins = cabins
        .map((row) => ({
          sps_id: row.id, //库存ID
          cabin_id: row.cabin_id, //舱房ID
          room_num: row.roomNum, //房间数
          amount: row.totalPrice, //总金额
          adult_num: row.adultNum, //成人数 切舱为0
          child_num: row.childNum, //儿童数 切舱为0
          diff_room_num: row.diffRoomPriceNum, //单房差数 切舱为0
          child_bed_num: row.childBedNum, //儿童加床数 切舱为0
          // adult_bed_num: row.adultBedNum
        }))
        .filter((item) => !!item.amount);

      let { code, data, msg } = await this.submitOrderBooking({
        product_no: this.productNo,
        date: this.currentVoyage.date,
        spd_id: this.currentVoyage.id,
        sale_type: 2,
        cabins,
      });

      if (code !== 10000) {
        this.$message.error(msg);
        return;
      }
      this.$router.push({
        path: "/product/cruise/booking",
        query: {
          booking_no: data.booking_no,
        },
      });
    },
    showCanbinDetailWithDialog(stockData) {
      const dialog = this.$createCabinDialog({
        $props: {
          data: stockData,
        },
      }).show()
    },
  },
})
</script>

<style lang="scss" scoped>

@import "./scss/booking-table.scss";

</style>
